// extracted by mini-css-extract-plugin
export default {"cogPlayIcon":"CogPlayIcon_cogPlayIcon__8uu20"};